export default "__VITE_ASSET__cabb1c4a__"